// src/services/profile.ts
//
// Profile-domain service. Wraps the GET/UPDATE nutritionist profile endpoints
// so the profile pages deal in typed function calls rather than raw fetch +
// JSON parsing. Response shape is intentionally left as `any` until the
// backend payload is locked.

import { apiFetch } from "../Component/api/apiFetch";
import { API_URLS } from "../Component/api/url";
import { handleJson } from "./http";

export const getProfile = (_nutristId?: string | number): Promise<any> =>
  handleJson(apiFetch(API_URLS.GET_PROFILE, { method: "GET" }));

export const updateProfile = (
  _nutristId: string | number | undefined,
  payload: Record<string, any>
): Promise<any> =>
  handleJson(
    apiFetch(API_URLS.UPDATE_PROFILE, {
      method: "POST",
      body: JSON.stringify(payload),
    })
  );

export const updateProfilePicture = (file: File): Promise<any> => {
  const formData = new FormData();
  formData.append("nutrist_profile", file);
  return handleJson(
    apiFetch(API_URLS.UPDATE_PROFILE_PICTURE, {
      method: "POST",
      body: formData,
    })
  );
};
